import { isNumber, isString } from '../fold-helpers';
import { createWidgetNormalizer } from '../create-widget-normalizer';

/**
 * `videoUrl` is the PERSISTED field name, so a model that has seen the entity reaches for it before
 * it reaches for `url`; `link`/`href` are what it reaches for when it has only seen the tool. All of
 * them mean the same thing here, and a plain `z.object()` would strip every one of them silently —
 * a hard "url required" failure on create, a success-reporting no-op on update.
 */
const URL_SYNONYM_KEYS = ['videoUrl', 'src', 'link', 'href', 'video', 'youtubeUrl', 'vimeoUrl'] as const;

/** Plain `width` is the pixel cap, as it is for image — the editor's width input writes `maxWidth`. */
const MAX_WIDTH_SYNONYM_KEYS = ['width'] as const;

const PREVIEW_SYNONYM_KEYS = ['poster', 'thumbnail', 'preview', 'previewImage'] as const;

const videoNormalizer = createWidgetNormalizer({
    rules: [
        { target: 'url', synonyms: URL_SYNONYM_KEYS, accepts: isString },
        { target: 'maxWidth', synonyms: MAX_WIDTH_SYNONYM_KEYS, accepts: isNumber },
        { target: 'previewUrl', synonyms: PREVIEW_SYNONYM_KEYS, accepts: isString },
    ],
    horizontalAlign: true,
    /**
     * `videoType` and `isShorts` are stripped rather than accepted. They are derived from the link
     * (see `deriveVideoSource`), and a model that supplies its own would either agree with the
     * derivation — in which case the field is noise — or contradict it, which the entity's
     * `superRefine` rejects with a message about `videoUrl` that names none of this.
     */
    extraFlatKeys: ['videoType', 'isShorts'],
});

export function normalizeVideoWidgetArgs(raw: unknown): unknown {
    return videoNormalizer.normalize(raw);
}
